import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { createStore, combineReducers, Reducer, compose, applyMiddleware } from 'redux';

import { layout } from './layout/layout.reducer';
import { pages } from './pages/pages.reducer';
import { topics } from './topics/topics.reducer';

export const history = createBrowserHistory();

const reducers = combineReducers({
  router: connectRouter(history),
  layout,
  pages,
  topics,
});

export type AppState = typeof reducers extends Reducer<infer S> ? S : {};

export const store = createStore(
  reducers,
  compose(applyMiddleware(routerMiddleware(history))),
);
